import {useEffect, useState} from "react";

function calculateTimeDiff(date) {
    const difference = new Date() - new Date(date);
    return msToTime(difference);
}

function msToTime(duration) {
    let hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
    let minutes = Math.floor((duration / (1000 * 60)) % 60);
    let seconds = Math.floor((duration / 1000) % 60);
    hours = (hours < 10) ? "0" + hours : hours;
    minutes = (minutes < 10) ? "0" + minutes : minutes;
    seconds = (seconds < 10) ? "0" + seconds : seconds;

    return hours + ":" + minutes + ":" + seconds;
}

export default function UseHubHeader({buildId, buildCreateAt, buildLaunched}) {
    const [opened, setOpened] = useState(false);
    const [elapsedTime, setElapsedTime] = useState(calculateTimeDiff(buildCreateAt));

    useEffect(() => {
        const interval = buildLaunched
            ? setInterval(() => {
                const diff = calculateTimeDiff(buildCreateAt);

                setElapsedTime(diff);
            }, 1000)
            : null;

        return () => {
            if (interval) clearInterval(interval);
            setElapsedTime(undefined);
        };
    }, [buildId, buildCreateAt, buildLaunched]);

    const handleOpen = () => {
        setOpened(true);
    };

    const handleClose = () => {
        setOpened(false);
    };

    return {
        opened,
        elapsedTime,
        handleOpen,
        handleClose
    }
}